import './UnauthenticatedApp.css'
import Register from './profile/Register.js'
import Login from './profile/Login.js'
import VerifyEmail from './profile/VerifyEmail.js'
import ForgotPassword from './profile/ForgotPassword.js'

import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const pathToScreen = (pathname) => {
  if (pathname === '/register') return 'register';
  if (pathname === '/forgot-password') return 'forgot';
  return 'login';
};

const UnauthenticatedApp = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const inviteToken = params.get('invite');
  const initialPhone = params.get('phone') || "";
  const initialName  = params.get('name')  || "";

  const [screen, setScreen] = useState(inviteToken || initialPhone ? 'register' : pathToScreen(location.pathname));
  const [user, setUser] = useState({});
  const [code, setCode] = useState('');
  const [activeInviteToken, setActiveInviteToken] = useState(inviteToken || '');

  const goTo = (newScreen) => {
    setScreen(newScreen);
    if      (newScreen === 'register') navigate('/register');
    else if (newScreen === 'forgot')   navigate('/forgot-password');
    else                               navigate('/login');
  };

  return (
    <div className="UnauthenticatedApp">
      <div className="auth-brand">
        <div className="auth-logo-mark">
          <span className="auth-logo-letters">ZM</span>
          <div className="auth-logo-bar" />
        </div>
        <span className="auth-brand-name">ZapManejo</span>
        <span className="auth-brand-sub">GESTÃO RURAL</span>
      </div>

      {screen === 'login' &&
        <Login
          onRegisterClick={() => goTo('register')}
          onForgotPasswordClick={() => goTo('forgot')}
        />
      }

      {screen === 'register' &&
        <Register
          inviteToken={activeInviteToken}
          initialPhone={initialPhone}
          initialName={initialName}
          onLoginClick={() => goTo('login')}
          onRegisterSuccessfull={(response) => {
            if (response.success) {
              setScreen('verify');
              setUser(response.user);
              setCode(response.verification_code);
              setActiveInviteToken(response.invite_token || '');
            } else {
              console.log('error', response);
            }
          }}
        />
      }

      {screen === 'verify' &&
        <VerifyEmail
          email={user.email}
          code={code}
          inviteToken={activeInviteToken}
          onLoginClick={() => goTo('login')}
        />
      }

      {screen === 'forgot' &&
        <ForgotPassword
          onLoginClick={() => goTo('login')}
        />
      }
    </div>
  );
}
export default UnauthenticatedApp;
